// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1rCe5","dragIcon":"Choice_dragIcon__1M8y1","left":"Choice_left__1w_hY","input":"Choice_input__ClNqe"};